// Pure helper functions extracted verbatim from DealerForm.vue. None of them
// touch component state; they are mixed back into the component's `methods` so
// every existing `this.X(...)` call site and template binding keeps working.

export function sleep(ms = 0) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export const customEmail = (value) => {
  if (typeof value === "undefined" || value === null || value === "") {
    return true;
  }

  // If the email doesn't end with seatow.com, do not allow to
  if (value.endsWith("@seatow.com")) {
    return true;
  }

  var res = value.charAt(value.length - 1);
  if (res == ",") {
    return false;
  }

  return /^[\W]*([\w+\-.%]+@[\w\-.]+\.[A-Za-z]{2,4}[\W]*,{1}[\W]*)*([\w+\-.%]+@[\w\-.]+\.[A-Za-z]{2,4})[\W][@seatow.com$]*$/.test(
    value
  );
};

export function formatDate(date) {
  // Format date as "Month Day, Year" (e.g., "January 15, 2025")
  if (!date) return "";

  const options = { year: "numeric", month: "long", day: "numeric" };
  return new Date(date).toLocaleDateString("en-US", options);
}

export function capitalizeFirstLetter(str) {
  if (str === undefined || str == null || str == "") {
    return "";
  }
  return str[0].toUpperCase() + str.slice(1);
}

export function stripTheGarbage(e) {
  if ((e.keyCode < 48 && e.keyCode !== 46) || e.keyCode > 59) {
    e.preventDefault();
  }
}

export function stripNonAlpha(e) {
  if (/^[a-zA-Z ]+$/i.test(e.key) == false) {
    e.preventDefault();
  }
}

export function readableCardName(name) {
  if (name == "ProfMariner") {
    return "Professional Mariner";
  } else if (~name.indexOf("Trial")) {
    var split_name = name.split("Trial");
    return name.substring(0, 5) + " " + split_name[1];
  }
  return name;
}

export function abbrRegion(input, to) {
  var states = [
    ["Alabama", "AL"],
    ["Alaska", "AK"],
    ["American Samoa", "AS"],
    ["Arizona", "AZ"],
    ["Arkansas", "AR"],
    ["Armed Forces Americas", "AA"],
    ["Armed Forces Europe", "AE"],
    ["Armed Forces Pacific", "AP"],
    ["California", "CA"],
    ["Colorado", "CO"],
    ["Connecticut", "CT"],
    ["Delaware", "DE"],
    ["District Of Columbia", "DC"],
    ["Florida", "FL"],
    ["Georgia", "GA"],
    ["Guam", "GU"],
    ["Hawaii", "HI"],
    ["Idaho", "ID"],
    ["Illinois", "IL"],
    ["Indiana", "IN"],
    ["Iowa", "IA"],
    ["Kansas", "KS"],
    ["Kentucky", "KY"],
    ["Louisiana", "LA"],
    ["Maine", "ME"],
    ["Marshall Islands", "MH"],
    ["Maryland", "MD"],
    ["Massachusetts", "MA"],
    ["Michigan", "MI"],
    ["Minnesota", "MN"],
    ["Mississippi", "MS"],
    ["Missouri", "MO"],
    ["Montana", "MT"],
    ["Nebraska", "NE"],
    ["Nevada", "NV"],
    ["New Hampshire", "NH"],
    ["New Jersey", "NJ"],
    ["New Mexico", "NM"],
    ["New York", "NY"],
    ["North Carolina", "NC"],
    ["North Dakota", "ND"],
    ["Northern Mariana Islands", "NP"],
    ["Ohio", "OH"],
    ["Oklahoma", "OK"],
    ["Oregon", "OR"],
    ["Pennsylvania", "PA"],
    ["Puerto Rico", "PR"],
    ["Rhode Island", "RI"],
    ["South Carolina", "SC"],
    ["South Dakota", "SD"],
    ["Tennessee", "TN"],
    ["Texas", "TX"],
    ["US Virgin Islands", "VI"],
    ["Utah", "UT"],
    ["Vermont", "VT"],
    ["Virginia", "VA"],
    ["Washington", "WA"],
    ["West Virginia", "WV"],
    ["Wisconsin", "WI"],
    ["Wyoming", "WY"],
  ];

  var provinces = [
    ["Alberta", "AB"],
    ["British Columbia", "BC"],
    ["Manitoba", "MB"],
    ["New Brunswick", "NB"],
    ["Newfoundland", "NF"],
    ["Northwest Territory", "NT"],
    ["Nova Scotia", "NS"],
    ["Nunavut", "NU"],
    ["Ontario", "ON"],
    ["Prince Edward Island", "PE"],
    ["Quebec", "QC"],
    ["Saskatchewan", "SK"],
    ["Yukon", "YT"],
  ];

  var regions = states.concat(provinces);

  var i;
  if (to == "abbr") {
    input = input.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
    for (i = 0; i < regions.length; i++) {
      if (regions[i][0] == input) {
        return regions[i][1];
      }
    }
  } else if (to == "name") {
    input = input.toUpperCase();
    for (i = 0; i < regions.length; i++) {
      if (regions[i][1] == input) {
        return regions[i][0];
      }
    }
  }
}

/**
 * Generates a GUID string.
 * @returns {string} The generated GUID.
 * @example af8a8416-6e18-a307-bd9c-f2c947bbb3aa
 * @author Slavik Meltser.
 * @link http://slavik.meltser.info/?p=142
 */
export function guid() {
  function _p8(s) {
    var p = (Math.random().toString(16) + "000000000").substr(2, 8);
    return s ? "-" + p.substr(0, 4) + "-" + p.substr(4, 4) : p;
  }

  return _p8() + _p8(true) + _p8(true) + _p8();
}

export function EnsureIsInt(number) {
  return Number.isInteger(number);
}

export function GetLastFour(number) {
  if (number === null) {
    return "";
  }
  if (number.length <= 4) {
    return number;
  }

  return number.slice(number.length - 4);
}

export function GetCardType(number) {
  // visa
  if (
    number == null ||
    number === null ||
    number === undefined ||
    number == "" ||
    number == " "
  ) {
    return "Visa";
  }

  var re = new RegExp("^4");
  if (number.match(re) != null) return "Visa";

  // Mastercard
  // Updated for Mastercard 2017 BINs expansion
  if (
    /^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/.test(
      number
    )
  )
    return "Mastercard";

  // AMEX
  re = new RegExp("^3[47]");
  if (number.match(re) != null) return "AMEX";

  // Discover
  re = new RegExp(
    "^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)"
  );
  if (number.match(re) != null) return "Discover";

  return "";
}

// The subset of helpers that DealerForm exposes as component methods (used by
// the template and by `this.X(...)` call sites).
export const pureHelperMethods = {
  formatDate,
  capitalizeFirstLetter,
  stripTheGarbage,
  stripNonAlpha,
  readableCardName,
  abbrRegion,
  guid,
  EnsureIsInt,
  GetLastFour,
  GetCardType,
};
